export default __webpack_public_path__ + "static/im-685ca372bf9b619ebb3ca352c3fbba81.svg";